import { Radius, Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1.08fr);
  gap: ${Spacing.md}px;
`;

export const SummaryCard = styled.div<{ $fullWidth?: boolean }>`
  background: ${ColorV2.White};
  border: none;
  border-radius: ${Radius.xl}px;
  padding: ${Spacing.md}px;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.sm}px;
  min-width: 0;
  grid-column: ${(props) => (props.$fullWidth ? "1 / -1" : "auto")};
`;

export const SummaryLabel = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const SummaryValue = styled.span`
  ${TypographyV2.h5}
  color: ${ColorV2.Blue1};
  white-space: nowrap;
`;

export const SummaryActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.sm}px;
`;

export const SummaryAction = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
`;

export const SummaryDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.xs}px;
`;

export const SummarySettingsRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.sm}px;
`;

export const SummarySettingsRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: ${Spacing.md}px;
  align-items: start;
`;

export const SummarySettingsRowLabel = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  min-width: 0;
`;

export const SummarySettingsRowValue = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  min-width: 0;
  text-align: right;
  word-break: break-word;
`;

export const SummaryMetaRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.sm}px;
  margin-top: ${Spacing.sm}px;
`;

export const SummarySettingsLink = styled.button`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue3};
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: right;
  text-decoration: underline;

  &:hover {
    color: ${ColorV2.Blue1};
  }
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
`;

export const SectionDescription = styled.p`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
  margin: 0;
`;

export const ExpandableSectionCard = styled.section`
  background: ${ColorV2.White};
  border: none;
  border-radius: 24px;
  overflow: hidden;
`;

export const ExpandableSectionButton = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  padding: ${Spacing.md}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.md}px;
`;

export const ExpandableSectionMain = styled.div`
  display: flex;
  align-items: flex-start;
  min-width: 0;
`;

export const ExpandableSectionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.xs}px;
  min-width: 0;
`;

export const ExpandableSectionTitle = styled.h3<{
  $tone: "default" | "danger";
}>`
  ${TypographyV2.b1}
  color: ${(props) =>
    props.$tone === "danger" ? ColorV2.NegativeRed : ColorV2.Blue1};
  margin: 0;
`;

export const ExpandableSectionSubtitle = styled.p`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
  margin: 0;
`;

export const ExpandableSectionChevron = styled.span<{ $isOpen: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.2s ease;
`;

export const ExpandableSectionBody = styled.div`
  padding: 0 ${Spacing.md}px ${Spacing.md}px;
`;

export const WorkerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.sm}px;
`;

export const WorkerRow = styled.div<{ $tone?: "default" | "danger" }>`
  background: ${(props) =>
    props.$tone === "danger" ? ColorV2.NegativeRedLight : ColorV2.White};
  border: none;
  border-radius: ${Radius.xl}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.md}px;
  padding: 14px ${Spacing.md}px;
`;

export const WorkerName = styled.span<{ $tone?: "default" | "danger" }>`
  ${TypographyV2.b2}
  color: ${(props) =>
    props.$tone === "danger" ? ColorV2.NegativeRed : ColorV2.Blue1};
  min-width: 0;
`;

export const WorkerAmount = styled.span`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  flex-shrink: 0;
`;

export const InfoCard = styled.div`
  background: ${ColorV2.White};
  border: none;
  border-radius: ${Radius.xl}px;
  padding: ${Spacing.md}px;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.sm}px;
`;

export const InfoTitle = styled.h4`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const FooterActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${Spacing.md}px;
`;

export const StateText = styled.div`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
`;
